import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { TaskService } from 'src/app/services/task.service';
import { AlertComponent } from '../../alert/alert.component';
import { DocumentManagementMasterService } from 'src/app/services/document-management-master.service';
import { NcdclientService } from 'src/app/services/NCD/ncdclient.service';
declare var $: any;
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import data from 'src/app/helpers/fields';

@Component({
  selector: 'app-edit-master-document',
  templateUrl: './edit-master-document.component.html',
  styleUrls: ['./edit-master-document.component.css']
})
export class EditMasterDocumentComponent implements OnInit {

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();

  public environmentSettings: any;
  userList: any;
  fieldList = data;
  fieldNames: any = [];
  documentsDataEntryFieldsAcessrights: any = [];
  fileExtension: boolean = true;

  // documentID: any;
  // userForm: FormGroup;
  id: any;
  selectedUser: any = {};
  ActiveUsers: any;
  addWordDocForm: FormGroup;
  addDataEntryFieldForm: FormGroup;
  subDocuments: any[];
  SubDocId: any;
  addBtn: boolean = true;
  //typeHasError: boolean = true;
  docsToUpload: Array<File>;
  FileOrignalName: any;
  changedName: any;
  masterDocId: any;
  serialNo: any;
  docName: any;
  srNo: any;
  docDetails: any;
  isDocNameBlank: boolean;
  UploadFileName: any;
  downloadSingleFile: string;
  downloadFilePath: any;
  showUploadTemplateBtn: boolean = false;
  disabledOnclick: boolean;
  uploadedTemplateMasterDocId: any;
  typeHasError: boolean;
  storeSelectedIds: any = []
  selectedUserModal: any = [];

  constructor(private ncdService: NcdclientService,
    private activatedRoute: ActivatedRoute,
    private alert: AlertComponent,
    private commonFunction: CommonFunction,
    private taskService: TaskService, private router: Router,
    private documentManagementMasterService: DocumentManagementMasterService) {
    // this.userForm = new FormGroup({
    //   userId: new FormControl('')
    // })
  }

  ngOnInit() {

    this.addWordDocForm = new FormGroup({
      SrNo: new FormControl('', [Validators.required]),
      DocumentName: new FormControl('', [Validators.required]),
      AccessRights: new FormControl('', [Validators.required])
    });
    console.log(this.addWordDocForm)

    this.addDataEntryFieldForm = new FormGroup({
      SrNo: new FormControl('', [Validators.required]),
      FieldName: new FormControl('', [Validators.required]),
    });
    console.log(this.addDataEntryFieldForm)

    // this.dtOptions = {
    //   scrollX: true,
    //   deferRender: true,
    //   stateSave: false,
    //   stateDuration: -1,
    //   scrollY: "420px",
    //   scrollCollapse: true,
    //   destroy: true,
    //   pagingType: 'full_numbers',
    //   paging: true,
    //   pageLength: 10,
    //   search: true,
    //   order: [[0, 'asc']],
    //   columnDefs: [{ orderable: false, targets: [0, 1, 2] }],
    //   lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
    //   rowReorder: {
    //     selector: 'td.reOrderRow'
    //   }
    // };

    this.dtOptions = {
      destroy: true,
      scrollY: "300px",
      scrollCollapse: true,
      scrollX: true,
      deferRender: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      stateSave: false,
      serverSide: false,
      stateDuration: -1,
      search: true,
      order: [[0, 'asc']],
      columnDefs: [{ orderable: false, targets: [0, 1, 2, 3, 4] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      rowReorder: {
        selector: 'td.reOrderRow'
      }

    };
    $("#subDocTable").DataTable().on('row-reorder', (e, newOrderDataList, changes) => {
      console.log(newOrderDataList);
      console.log(changes)
      //  TODO    
    });
    this.activatedRoute.params.subscribe(params => {
      this.masterDocId = params['id'];
      console.log(params)
      this.getDocument();
      this.getUserList();
      this.getSubDocumentsByDocumentId();
    });
  }

  noBlankSpaceAtStart(ev) {
    if (ev.which === 32 && ev.target.selectionStart === 0) {
      return false;
    }
  }
  back() {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['ncd', 'document', 'generation', 'mster', 'setup'] } }],
      { relativeTo: this.activatedRoute.parent });
  }
  resetPopUp() {
    this.addBtn = true;
    this.addWordDocForm.controls.SrNo.setValue('');
    this.addWordDocForm.controls.DocumentName.setValue('');
    this.addWordDocForm.controls.AccessRights.setValue('');
  }

  resetDataEntryFields() {
    this.addDataEntryFieldForm.controls.SrNo.setValue('');
    this.addDataEntryFieldForm.controls.FieldName.setValue('');
  }

  getDocument() {
    this.ncdService.getDocumentBy(this.masterDocId).subscribe(resData => {
      this.docDetails = resData;
      let srNumber = resData.srNo;
      this.srNo = srNumber;

      this.serialNo = srNumber;
      this.docName = resData.documentName;

      this.uploadedTemplateMasterDocId = resData.DocumentTemplate.DocumentManagementID
      this.getActiveUser();
    }, error => {
      // console.log("TCL: EditMasterDocumentComponent -> getUserList -> error", error);
    })
  }


  getUserList() {
    this.taskService.getUsersList().subscribe(resData => {
      if (resData.result != undefined) {
        this.userList = (resData.result).map(function (element) {
          return {
            'label': element.FirstName + " " + element.LastName,
            'value': element._id
          }
        });

      }
      console.log(this.userList)
    }, error => {
      // console.log("TCL: EditMasterDocumentComponent -> getUserList -> error", error);
    })
  }

  getActivatedUser(fieldNames: any[]): void {
    return fieldNames.forEach(field => {
      const fieldName = field.name.replace(/ /g, '').toLowerCase();
      const matchingUser = this.ActiveUsers.find(user => user.fieldName === field.name);
      if (matchingUser) {
        return this.selectedUser[fieldName] = matchingUser.userAccessId;
      }
    });
  }

  getActiveUser() {
    this.ncdService.getActiveUser(this.masterDocId).subscribe(
      (resData: any[]) => {
        this.ActiveUsers = resData;
        const filedNames = this.fieldList.find(ele => ele.srNo.toString() === this.srNo.toString());
        if (filedNames) {
          filedNames.filedName.forEach((field: any) => {
            const ngField = field.name.replace(/ /g, '').toLowerCase();
            field['ngField'] = ngField;
          });
          this.getActivatedUser(filedNames.filedName);
          this.fieldNames = filedNames;
        }
      },
      (error) => {
        console.error('Error fetching active users:', error);
      }
    );
  }

  updateDocumentName() {
    this.disabledOnclick = true;
    var updateDocObj = {
      _id: this.docDetails._id,
      srNo: this.docDetails.srNo,
      documentname: this.docName
    }

    this.ncdService.updateDocName(updateDocObj).subscribe(resData => {
      this.disabledOnclick = false;
      console.log("********resData", resData)
      if (resData.documentname == "") {
        this.alert.error('Document Name field are required or invalid ');

      } else if (updateDocObj.documentname == "") {
        this.alert.error('Document Name field are required or invalid ');

      }
      else {

        this.alert.success('Document name updated successfully');
      }
    }, error => {
      this.alert.error('Oops something went wrong');
    })

  }

  checkDocNameOnKeyup() {
    if (this.docName != '') {
      this.isDocNameBlank = false;
    } else {
      this.isDocNameBlank = true;
    }
  }
  
  addUser(selectedIds: any[], fieldData: any): void {
    const data = {
      NCDMasterDocId: this.masterDocId,
      issueId: null,
      userName: null, // You can remove this line if it's not needed
      userAccessId: null, // You can remove this line if it's not needed
      fieldName: fieldData.name,
      fieldType: fieldData.type,
      fieldValid: fieldData.readonly,
      fieldKey: fieldData.name.replace(/ /g, ''),
      status: 'Active'
    };
    // Iterate over selectedIds to handle each selected user
    selectedIds.forEach(userId => {
      const userData = this.userList.find(user => user.value === userId);
      if (userData) {
        data.userName = userData.label; // Set userName based on selected user's name
        data.userAccessId = userData.value; // Set userAccessId based on selected user's id
        // Call your service method to allow user to update
        this.ncdService.allowUsertoUpdate(data).subscribe(
          resData => {
            // console.log("TCL: EditMasterDocumentComponent -> allowUserToUpdate -> resData", resData);
            this.alert.success(resData.message);
          },
          error => {
            console.error('Error allowing user to update:', error);
          }
        );
      }
    });
  }

  onDeSelect(items: any, fieldData: any) {
    console.log('de', items, fieldData);
    const data = {
      NCDMasterDocId: this.masterDocId,
      issueId: null,
      userName: null, // You can remove this line if it's not needed
      userAccessId: null, // You can remove this line if it's not needed
      fieldName: fieldData.name,
      fieldType: fieldData.type,
      fieldValid: fieldData.readonly,
      fieldKey: fieldData.name.replace(/ /g, ''),
      status: 'none'
    };
    const userData = this.userList.find(user => user.value === items?.value?.value);
    if (userData) {
      data.userName = userData.label;
      data.userAccessId = userData.value;
      this.ncdService.allowUsertoUpdate(data).subscribe(
        resData => {
          console.log("TCL: EditMasterDocumentComponent -> allowUserToUpdate -> resData", resData);
        },
        error => {
          console.error('Error allowing user to update:', error);
        }
      );
    }
  }


  addSubDocuments() {
    this.disabledOnclick = true;
    console.log('addWordDocForm', this.addWordDocForm)
    var subDocumentObject = {
      SrNo: this.addWordDocForm.controls.SrNo.value,
      DocumentName: this.addWordDocForm.controls.DocumentName.value,
      AccessRights: this.addWordDocForm.controls.AccessRights.value,
      NCDMasterDocId: this.masterDocId
    }

    this.ncdService.saveSubDocuments(subDocumentObject).subscribe(resData => {
      this.disabledOnclick = false;
      if (resData.status == 0) {
        this.getSubDocumentsByDocumentId();
        $('#editMasterDocDialog').modal('toggle');
        this.alert.success(resData.message);
      } else {
        $('#editMasterDocDialog').modal('toggle');
        if (resData.err_fields) {
          this.alert.error(JSON.stringify(resData.err_fields) + ' fields are required');
        } else {
          this.alert.error(resData.message);
        }

      }
    })
  }

  addDataEntryFields() {
    this.disabledOnclick = true;
    var dataEntryFieldObject = {
      SrNo: this.addDataEntryFieldForm.controls.SrNo.value,
      FieldName: this.addDataEntryFieldForm.controls.FieldName.value,
    }

    this.ncdService.saveSubDocuments(dataEntryFieldObject).subscribe(resData => {
      this.disabledOnclick = false;
      if (resData.status == 0) {
        this.alert.success(resData.message);
      } else {
        this.alert.error(resData.message);
      }
    })
  }

  getSubDocumentsByDocumentId() {
    this.ncdService.getSubDocumentsByDocumentId(this.masterDocId).subscribe(resData => {
      if (resData.status == 0) {
        this.subDocuments = [];
        var subdocumentTable = $('#subDocTable').DataTable({ destroy: true });
        subdocumentTable.destroy();

        this.subDocuments = _.sortBy(resData.data, ["documentOrder"]);
        console.log("this.subDocuments++++++++++++++", this.subDocuments)
        if (this.subDocuments.length > 1) {
          this.showUploadTemplateBtn = true;
        } else {
          this.showUploadTemplateBtn = false;
        }
        this.dtTrigger.next();
      }
    })
  }

  getSubDocumentsBySubDocumentId(id) {
    this.addBtn = false;
    this.selectedUserModal = [];
    this.ncdService.getSubDocumentsBySubDocumentId(id).subscribe(resData => {
      if (resData.status == 0) {
        this.SubDocId = resData.data[0]._id;
        this.addWordDocForm.controls.SrNo.setValue(resData.data[0].SrNo);
        this.addWordDocForm.controls.DocumentName.setValue(resData.data[0].DocumentName);
        this.addWordDocForm.controls.AccessRights.patchValue(resData.data[0].AccessRights);
        $('#editMasterDocDialog').modal('toggle');
        console.log(this.addWordDocForm.value)
      }
    })
  }

  showDeleteConfirmationPopUp(deletingID) {
    this.SubDocId = deletingID;
    $('#confirmation').modal('toggle');
  }

  deleteSubDoc() {
    this.ncdService.deleteSubDocument(this.SubDocId).subscribe(resData => {
      if (resData.status == 0) {
        $('#confirmation').modal('toggle');
        this.alert.success('Document deleted successfully');
        this.getSubDocumentsByDocumentId();
      } else {
        $('#confirmation').modal('toggle');
        this.alert.error('Oops! Something went wrong');
      }
    })
  }

  updateSubDocuments() {
    this.disabledOnclick = true;
    console.log('fgf', this.addWordDocForm)
    // console.log("this.addWordDocForm.controls.AccessRights.value====udate====", this.addWordDocForm.controls.AccessRights.value);
    var subDocumentObject = {
      SrNo: this.addWordDocForm.controls.SrNo.value,
      DocumentName: this.addWordDocForm.controls.DocumentName.value,
      AccessRights: this.addWordDocForm.controls.AccessRights.value,
      NCDMasterDocId: this.masterDocId,
      SubDocumentId: this.SubDocId
    }

    this.ncdService.updateSubDocuments(subDocumentObject).subscribe(resData => {
      this.disabledOnclick = false;
      if (resData.status == 0) {
        $('#editMasterDocDialog').modal('toggle');
        this.getSubDocumentsByDocumentId();
        this.alert.success(resData.message);

      } else {

        $('#editMasterDocDialog').modal('toggle');
        if (subDocumentObject.SrNo == "") {
          this.alert.error('Sr. No field are required or invalid ');

        } else if (subDocumentObject.DocumentName == "") {
          this.alert.error('Document Name field are required or invalid ');

        }

        else if (subDocumentObject.SrNo == "" && subDocumentObject.DocumentName == "") {
          this.alert.error('Sr. No and Document Name field are required or invalid');

        }
        else {

          this.alert.error(resData.message);
        }


      }
    })
  }

  initiateDocumentUpload() {
    $(".fileUpload").val("");
    this.typeHasError = false;
    $("#documentUploadTitle").html("Upload Template");
    $("#docUploadDialog").modal('toggle');
  }

  docsChangeEvent(fileInput: any) {
    var checkfile = this.commonFunction.checkFileExtensionForAgendaDocuments(fileInput);
    if (checkfile) {
      this.docsToUpload = <Array<File>>fileInput.target.files;
      this.fileExtension = true;
      // this.typeHasError = false;
    } else {
      this.fileExtension = false;
      //this.typeHasError = true;
    }
    console.log("fileExtension", this.fileExtension);
    // this.docsToUpload = <Array<File>>fileInput.target.files;
  }

  // getFileURL(srNo) {
  //   const filePath = this.uploadedFiles.filter(ele => ele.SrNo === srNo);
  //   return filePath.length > 0 ? filePath[0] ? filePath[0].DocumentManagement ? environment.fileurl + filePath[0].DocumentManagement.FilePath : '' : '' : '';
  // }


  uploadDocFile() {
    var file = this.docsToUpload;
    return this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      if (result) {
        var documentName = this.FileOrignalName;
        var documentManagement = {
          "DocumentManagement": {
            DocumentName: Date.now() + '-' + documentName,
            DateOfDocument: new Date(),
            Upload: this.changedName,
            OriginalFileName: this.FileOrignalName,
            CompletedDate: null,
            DirectorID: null,
            DirectorKmp: "None",
            KMPID: null,
            MeetingTypeID: null,
            Overwrite: false,
            ParentDocumentTypeID: null,
            ParentSubDocumentTypeID: null,
            Remarks: null
          }
        }
        this.documentManagementMasterService.addDocumentManagement(documentManagement)
          .subscribe((docResponse: any) => {
            if (docResponse.status == 0) {
              var addedDocumentData = docResponse.result;
              // console.log("docResponse.result.FilePath------------",docResponse.result.FilePath);
              this.downloadFilePath = docResponse.result.FilePath;
              var docTemplateObj = {
                "DocName": documentName,
                "uploadFileName": this.changedName,
                "DocumentManagementID": addedDocumentData._id
              }
              this.ncdService.addDocumentTemplateFile(docTemplateObj, this.masterDocId)
                .subscribe(responseData => {
                  if (responseData.status == 0) {
                    this.getDocument();
                    this.getSubDocumentsByDocumentId();
                    $("#docUploadDialog").modal('toggle');
                    this.alert.success("Document Uploaded Successfully");
                  } else {
                    this.alert.error("Something went wrong");
                  }
                })
            } else {
              this.alert.error("Something went wrong");
            }
          });
        this.docsToUpload = [];
      } else {
        this.alert.error("Oops, Something Went Wrong");
      }
    }, (error) => {

      this.alert.error("Invalid file.");
    })
  }

  makeFileRequest(url: string, params: Array<string>, files: Array<File>) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      var now = Date.now();
      for (var i = 0; i < files.length; i++) {
        formData.append("file", files[i], now + '-' + files[i].name.replace(',', ''));
        this.FileOrignalName = files[i].name.replace(',', '');
        this.changedName = now + '-' + files[i].name.replace(',', '');
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      var token = localStorage.getItem('token')
      xhr.open("POST", url, true);
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }

  downloadTemplateFile() {
    var token = localStorage.getItem('token')

    this.downloadSingleFile = environment.pssServerUrl + 'documentManagement/downloadSingleFileOnID/';
    window.location.href = this.downloadSingleFile + this.uploadedTemplateMasterDocId + '/' + token;
  }

  documentsSaveOrder() {
    this.disabledOnclick = true;
    var documentTable = $('#subDocTable').DataTable();
    var subDocuments = documentTable.rows().data();

    var documentListWithOrder = [];

    for (let subDoc of subDocuments) {
      console.log("subDoc============================", subDoc)
      documentListWithOrder.push({
        _id: subDoc[1],
        Order: subDoc[0]
      });
    }

    this.ncdService.reOrderingOfDocument(documentListWithOrder, this.masterDocId).subscribe(data => {
      if (data.status == 0) {
        this.disabledOnclick = false;
        this.subDocuments = [];
        // this.subDocuments = data.data;
        $("#subDocTable").DataTable().destroy();
        this.subDocuments = data.data
        this.subDocuments = _.sortBy(this.subDocuments, ["documentOrder"]);
        this.dtTrigger.next();
        this.alert.success("Order of the documents saved successfully.");
        console.log("documentsSaveOrder subDoc============================", this.subDocuments)

      }
    });
  }

  // downloadTemplate(data) {
  //   var token = localStorage.getItem('token')
  //   this.downloadSingleFile = environment.pssUrl + 'documentManagement/downloadSingleFileOnID/';
  //   window.location.href = this.downloadSingleFile + data + "/" + token;
  // }

}
